import { type CompanyConfig, TimeFormat } from '../interface';

// TODO: need update!!!
export const LocaleeConfig: CompanyConfig = {
  id: 'd05f30ba-ceb5-4633-a3b6-aa0f9463954f',
  lang: 'en',
  langs: ['en'],
  name: 'Localee',
  nameSecondary: 'Localee',
  currency: '$',
  currencyCode: 'USD',
  officialName: 'Localee',
  email: 'support@shoplocalee.com',
  feedbackEmail: 'support@shoplocalee.com',
  contactEmail: 'support@shoplocalee.com',
  phonePlaceholder: '+1',
  defaultPhoneCode: '+1',
  phoneNumber: '201-655-3388',
  ageRestricted: 21,
  timeZone: 'America/New_York',
  minimalOrderFeeThreshold: 700,
  address: 'Teaneck Rd, Ridgefield Park, NJ 07660, USA',
  canonical: 'https://buylocalee.com',
  defaultVolumeDisplay: '1x',
  warehouse: {
    default: 'NJSB1',
    minimalOrderFeeWarehouseCodes: [],
    location: { lat: 40.8537291, lng: -74.0197964 },
  },
  map: {
    center: { lat: 40.89753813649296, lng: -74.09670413033002 },
    zoom: 12,
  },
  paymentMethods: ['gpay', 'applepay', 'visa', 'mc', 'amex', 'discover'],
  timeFormat: TimeFormat.h12,
  useAutocompleteAddress: true,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    // whatsapp: 'https://wa.me/971501515042',
    // facebook: 'https://www.facebook.com/cheers.citydrinksuae/',
    // instagram: 'https://www.instagram.com/citydrinksuae/',
    // tiktok: 'https://www.tiktok.com/@citydrinksuae/',
    // youtube: 'https://www.youtube.com/channel/UCzwC746u4WxzAs0fPOMfSMA/',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'SWIFFTUCDAVIS',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://onelink.to/tms6u7',
  },
  points: {
    value: '1=1c.',
    pointsPerUnit: 15,
    icon: 'coins',
  },
  appStoreUrl: {
    ios: 'https://apps.apple.com/us/app/localee-delivery/id6741045710',
    android: 'https://play.google.com/store/apps/details?id=com.localee.app',
  },
  apis: {},
  countryCode: 'US',
  taxName: 'Sales TAX',
  cashBanknotes: [50, 100, 150, 200, 500, 1000],
  license: {
    name: 'Localee',
    numberPrinary: '',
  },
};
